import React from 'react';
import {Helmet} from "react-helmet";

const PageHelmet = ({title}) => <Helmet>
    <title>{ title }</title>
</Helmet>

export default PageHelmet;
